import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AuiIconComponent } from '@ral/ui:aui/icons';
import { AuiItemComponent } from '@ral/ui:aui/item';
import { StoryContainerComponent } from '@storyteller/container';
import { StoryDescriptionComponent } from '@storyteller/description';
import { StoryFeatureComponent } from '@storyteller/feature';
import { StoryImageComponent, StoryImageSourceComponent } from '@storyteller/image';
import { StoryMapComponent } from '@storyteller/map';
import { StoryTitleComponent } from '@storyteller/title';
import { AcpSystemComponent } from '../components/acp-system.component';
import { AntBotCncComponent } from '../components/antbot-pro-cnc.component';
import { EasyLeanKitComponent } from '../components/easy-lean-kit.component';
import { MillBarFeederComponent } from '../components/mill-bar-feeder.component';
import { AuiLoadingComponent } from '@ral/ui:aui/aui-loading';
import { ROUTES_NAMES } from '../utils/routes';
@Component({
    selector: 'app-home-page',
    imports: [
        StoryFeatureComponent,
        StoryImageComponent,
        StoryImageComponent,
        StoryTitleComponent,
        StoryDescriptionComponent,
        StoryContainerComponent,
        MillBarFeederComponent,
        EasyLeanKitComponent,
        AntBotCncComponent,
        AcpSystemComponent,
        StoryMapComponent,
        StoryImageSourceComponent,
        AuiIconComponent,
        AuiLoadingComponent,
        AuiItemComponent,
        RouterLink,
    ],
    template: `
        <header class="overflow-hidden bg-info text-surface-background">
            <div
                class="relative m-auto flex max-h-[1000px] max-h-[1400px] min-h-0 max-w-[1800px] items-stretch justify-center md:min-h-[calc(100vh-100px)]"
            >
                <story-container
                    [space]="'pt-0 pb-10 md:py-[80px] h-full'"
                    [skipTopPadding]="true"
                    [skipSmallScreenTopPadding]="true"
                >
                    <div class="md:hidden">
                        <story-image
                            fetchPriority="high"
                            class="m-auto mb-8 block aspect-[532/688] max-h-[40vh] w-[63%] max-w-[240px]"
                            [role]="'presentation'"
                            [loading]="'eager'"
                        >
                            <story-source
                                [src]="'assets/images/ant-not-blur.svg'"
                                [allowWebP]="false"
                                [allowAvif]="false"
                                [width]="256"
                                fetchPriority="high"
                                [height]="332"
                            />
                        </story-image>
                    </div>
                    <div class="flex-col-reverse items-stretch gap-5 md:grid md:h-full md:grid-cols-2 lg:gap-10">
                        <div class="relative flex h-full flex-col justify-between">
                            <div></div>
                            <div
                                class="m bottom-0 left-0 right-0 top-0 m-auto hidden aspect-[532/688] max-h-[96%] max-w-[96%] md:absolute md:block md:max-w-full"
                            >
                                <story-image
                                    fetchPriority="high"
                                    class="block aspect-[532/688]"
                                    [role]="'presentation'"
                                    [loading]="'eager'"
                                >
                                    <story-source
                                        [src]="'assets/images/ant-cover-logo.svg'"
                                        [allowWebP]="false"
                                        [allowAvif]="false"
                                        [width]="532"
                                        fetchPriority="high"
                                        [height]="688"
                                    />
                                </story-image>
                            </div>
                            <story-title
                                class="relative z-10 block"
                                [headingLevel]="1"
                                [className]="'story-font-display3 pb-8'"
                            >
                                Prošlapeme vám cestu k&nbsp;automatizaci CNC obrábění
                            </story-title>
                            <div>
                                <story-feature class="relative z-10 block">
                                    <aui-icon icon="handshake" class="text-[28px]" />
                                    <story-title [headingLevel]="2" [className]="'story-font-headline3 pb-1'"
                                    >Partner, na kterého se můžete spolehnout
                                    </story-title
                                    >
                                    <story-description class="story-gray-text">
                                        Zajišťujeme komplexní řešení v&nbsp;oblasti průmyslové automatizace CNC
                                        obráběcích strojů a&nbsp;poskytujeme služby od návrhu, výroby až po konečnou
                                        instalaci přímo u&nbsp;vás včetně následné péče.
                                    </story-description>
                                </story-feature>
                            </div>
                        </div>
                        <div class="hidden md:block">
                            <div
                                class="rounded-top bottom-0 right-0 top-0 my-auto block w-[calc(50%-60px)] overflow-hidden md:absolute"
                            >
                                <!-- class="bottom-0 left-[60%] top-0 mx-[-20px] my-auto block overflow-hidden rounded sm:aspect-[600/320] md:absolute md:mx-0 md:aspect-[400/480] md:w-[50vw]" -->

                                <story-image
                                    class="rounded-top absolute right-0 top-0 block min-h-full overflow-hidden sm:aspect-[600/320] md:aspect-[400/480]"
                                    [fetchPriority]="'high'"
                                    [alt]="'Automatizace a robotizace'"
                                    [loading]="'eager'"
                                    [objectPosition]="'object-right-top'"
                                >
                                    <story-source
                                        [width]="600"
                                        [height]="720"
                                        src="assets/images/cover.jpg"
                                        media="(min-width: 1200px)"
                                    />
                                    <story-source
                                        [width]="400"
                                        [height]="480"
                                        src="assets/images/cover.jpg"
                                        media="(min-width: 768px)"
                                    />
                                    <!-- <story-source
                                    [width]="580"
                                    [height]="300"
                                    src="assets/images/cover.jpg"
                                    media="(min-width: 640px)"
                                /> -->
                                    <!-- <story-source
                                    [width]="600"
                                    [height]="320"
                                    src="assets/images/cover-wide.jpg"
                                    media="(min-width: 200px)"
                                /> -->
                                </story-image>
                            </div>
                        </div>
                    </div>
                </story-container>
            </div>
        </header>
        <section>
            <story-container [space]="'pt-6'" [skipTopPadding]="true" [skipSmallScreenTopPadding]="true">
                <div
                    class="w500:justify-between flex flex-wrap items-center justify-center gap-2"
                    aria-label="Partneři"
                    role="list"
                >
                    <div class="flex-none" role="listitem">
                        <story-image
                            [alt]="'Gressel'"
                            class="block aspect-[176/20] max-w-[88px] sm:max-w-[131px] w1100:max-w-[176px]"
                            [fetchPriority]="'low'"
                        >
                            <story-source [src]="'assets/images/gressel.png'" [width]="176" [height]="20" />
                        </story-image>
                    </div>
                    <div class="flex-none" role="listitem">
                        <story-image
                            [alt]="'Fanuc'"
                            class="block aspect-[166/47] max-w-[83px] sm:max-w-[115px] w1100:max-w-[166px]"
                            [fetchPriority]="'low'"
                        >
                            <story-source [src]="'assets/images/fanuc.png'" [width]="166" [height]="47" />
                        </story-image>
                    </div>
                    <div class="flex-none" role="listitem">
                        <story-image
                            [alt]="'Titgemeyer'"
                            class="block aspect-[200/78] max-w-[100px] sm:max-w-[136px] w1100:max-w-[200px]"
                        >
                            <story-source [src]="'assets/images/titgemeyer.png'" [width]="200" [height]="78" />
                        </story-image>
                    </div>
                    <div class="-my-2 hidden w-full tiny:block md:hidden" role="presentation"></div>
                    <div class="flex-none" role="listitem">
                        <story-image
                            [alt]="'Ralba'"
                            class="w500:ml-9 block aspect-[78/78] max-w-[39px] sm:max-w-[47px] md:ml-0 w1100:max-w-[78px]"
                            [fetchPriority]="'low'"
                        >
                            <story-source [src]="'assets/images/ralba.png'" [width]="78" [height]="78" />
                        </story-image>
                    </div>
                    <div class="flex-none" role="listitem">
                        <story-image
                            [alt]="'MK SET'"
                            class="block aspect-[178/126] max-w-[89px] sm:max-w-[122px] w1100:max-w-[178px]"
                            [fetchPriority]="'low'"
                        >
                            <story-source [src]="'assets/images/mkset.png'" [width]="178" [height]="126" />
                        </story-image>
                    </div>

                    <div class="flex-none" role="listitem">
                        <story-image
                            [alt]="'Schunk'"
                            class="block aspect-square max-w-[75px] sm:max-w-[110px] w1100:max-w-[151px]"
                            [fetchPriority]="'low'"
                        >
                            <story-source [src]="'assets/images/schunk.png'" [width]="151" [height]="151" />
                        </story-image>
                    </div>
                </div>
            </story-container>
        </section>
        <section>
            <div id="solutions" class="relative -top-12 lg:top-[-100px]"></div>
            <story-container>
                <story-title [headingLevel]="2" [className]="'story-font-headline1 pb-12'">Naše řešení</story-title>
                <div class="grid grid-cols-1 sm:grid-cols-2 gap-5 lg:grid-cols-3 lg:gap-10">
                    <div>
                        <app-mill-bar-feeder />
                    </div>

                    <div>
                        <app-easy-lean-kit />
                    </div>
                    <div>
                        <app-antbot-pro-cnc />
                    </div>
                    <div class="lg:col-span-3">
                        <app-acp-system />
                    </div>
                </div>
            </story-container>
        </section>
        <section class="bg-info text-surface-background">
            <div id="about" class="relative -top-12 lg:top-[-100px]"></div>
            <story-container>
                <div class="grid-col-1 grid items-center gap-5 md:grid-cols-2 lg:gap-10">
                    <div>
                        <story-title [headingLevel]="2" [className]="'story-font-headline1 pb-8'">
                            Od kořenů ve výrobě k&nbsp;inovacím pro celý svět
                        </story-title>
                        <story-description class="story-gray-text">
                            Jsme rodinná firma, která vyrostla z&nbsp;CNC výroby. Naše řešení automatizace
                            a&nbsp;robotizace vznikla z&nbsp;reálné potřeby ve výrobě naší partnerské firmy MK SET.
                            <br />
                            <br />
                            Naším cílem je urychlit a&nbsp;zjednodušit automatizaci po celém světě a&nbsp;šetřit firmám
                            i&nbsp;lidem čas, peníze a&nbsp;starosti. Jsme sourozenci strojaři s&nbsp;vášní pro chytrá
                            řešení.
                        </story-description>
                        <a
                            auiItem
                            [routerLink]="['/', ROUTES_NAMES.aboutUs]"
                            [color]="'primary'"
                            [size]="'40'"
                            class="mt-8 inline-flex"
                        >
                            <span auiItemLabel>Objevte náš příběh</span>
                        </a>
                    </div>
                    <div>
                        <story-image
                            [alt]="'Od kořenů ve výrobě k inovacím pro celý svět'"
                            class="block aspect-[0.8928571429] overflow-hidden rounded"
                        >
                            <story-source [src]="'assets/images/about-us.jpg'" [width]="500" [height]="560" />
                        </story-image>
                    </div>
                </div>
            </story-container>
            <story-container [skipTopPadding]="true" [skipSmallScreenTopPadding]="true">
                <div class="">
                    <div>
                        <story-title [headingLevel]="3" [className]="'story-font-headline1 pb-8'">
                            Náš tým
                        </story-title>
                        <story-description class="story-gray-text block max-w-[400px] overflow-hidden rounded pb-12">
                            Náš tým spojuje vizi, technické myšlení a&nbsp;precizní exekuci od nápadu po
                            výsledek.
                        </story-description
                        >
                    </div>
                    <div
                        class="items:center flex flex-col flex-wrap items-center justify-center gap-6 tiny:flex-row tiny:items-start w460:flex-nowrap md:justify-between md:gap-8"
                    >
                        <div class="tiny:w-[calc(50%-12px)] tiny:max-w-[260px] w460:w-auto">
                            <story-feature>
                                <story-image
                                    class="-mb-1 block aspect-square overflow-hidden rounded"
                                    [fetchPriority]="'low'"
                                    [alt]="'Antonín Solfronk'"
                                >
                                    <story-source
                                        [src]="'assets/images/antonin-solfronk.jpg'"
                                        [width]="260"
                                        [height]="260"
                                    />
                                </story-image>
                                <story-title [headingLevel]="4" [className]="'story-font-headline4'"
                                >Ing. Antonín Solfronk
                                </story-title>
                                <story-description> Vedoucí konzultant pro automatizaci</story-description>
                            </story-feature>
                        </div>
                        <div class="tiny:w-[calc(50%-12px)] tiny:max-w-[260px] w460:w-auto">
                            <story-feature>
                                <story-image
                                    class="-mb-1 block aspect-square overflow-hidden rounded"
                                    [fetchPriority]="'low'"
                                    [alt]="'Ludmila Vančo Solfronková'"
                                >
                                    <story-source
                                        [src]="'assets/images/ludmila-vanco-solfronkova.jpg'"
                                        [width]="260"
                                        [height]="260"
                                    />
                                </story-image>
                                <story-title [headingLevel]="4" [className]="'story-font-headline4'">
                                    Ing. Ludmila Vančo Solfronková
                                </story-title
                                >
                                <story-description> Projektový manažer</story-description>
                            </story-feature>
                        </div>
                        <div class="tiny:w-[calc(50%-12px)] tiny:max-w-[260px] w460:w-auto">
                            <story-feature>
                                <story-image
                                    class="-mb-1 block aspect-square overflow-hidden rounded"
                                    [fetchPriority]="'low'"
                                    [alt]="'MK SET s.r.o.'"
                                >
                                    <story-source [src]="'assets/images/mk-set.jpg'" [width]="260" [height]="260" />
                                </story-image>
                                <story-title [headingLevel]="4" [className]="'story-font-headline4'"
                                >MK SET s.r.o.
                                </story-title
                                >
                                <story-description> Investor a technický partner</story-description>
                            </story-feature>
                        </div>
                    </div>
                </div>
            </story-container>
        </section>
        <section>
            <div id="contact" class="relative -top-12 lg:top-[-100px]"></div>
            <story-container>
                <div class="flex flex-col items-center gap-5 md:flex-row lg:gap-8">
                    <div class="flex-1">
                        <story-title [headingLevel]="3" className="story-font-headline2 pb-2"
                        >Ozvěte se, nebo se za námi přijeďte podívat
                        </story-title
                        >
                        <story-description className="pb-2"
                        >Všechna naše řešení Vám rádi ukážeme v&nbsp;akci na pobočce našeho partnera MK SET s.r.o.
                        </story-description>
                        <div class="flex flex-col gap-2">
                            <address class="not-italic flex flex-row gap-2">
                                <aui-icon icon="mailbox" />
                                <story-description>U Vodárny 1506/1<br />Písek<br />397 01</story-description>
                            </address>
                            <div class="pb-2 flex flex-row gap-2 items-center">
                                <aui-icon icon="envelope" />
                                <a href="mailto:automation@antonyco.com">automation@antonyco.com</a>
                            </div>
                        </div>
                        <br /><br />
                        <div class="pb-2 flex flex-col gap-1">
                            <story-title [headingLevel]="4" [className]="'story-font-headline4 pb-1'">Ing. Ludmila Vančo
                                Solfronková
                            </story-title>
                            <div class="flex flex-row gap-2 items-center">
                                <aui-icon icon="envelope" />
                                <a href="mailto:ludmila.solfronkova@antonyco.com">ludmila.solfronkova@antonyco.com</a>
                            </div>
                            <div class="flex flex-row gap-2 items-center">
                                <aui-icon icon="phone" />
                                <a href="tel:+420733348555">+420 733 348 555</a>
                            </div>
                        </div>
                    </div>
                    <div
                        class="h-[400px] w-full flex-none md:w-[500px] w1100:w-[720px]"
                        aria-live="polite"
                        aria-atomic="true"
                    >
                        @defer (on viewport) {
                            <story-google-map class="block h-full w-full overflow-hidden rounded"></story-google-map>
                        } @placeholder {
                            <div class="flex h-full w-full flex-col items-center justify-center">
                                <aui-loading />
                                <p class="story-gray-text mt-4">Načítání...</p>
                            </div>
                        }
                    </div>
                </div>
            </story-container>
        </section>
    `,
})
export class HomePageComponent {
    readonly ROUTES_NAMES = ROUTES_NAMES;
}
